// extracted by mini-css-extract-plugin
module.exports = {"Grid":"Landing_Grid__3E3eP","Flex":"Landing_Flex__2cTkT","whole":"Landing_whole__1KkHm","selection":"Landing_selection__2bITD"};